module.exports = __webpack_public_path__ + "static/media/ru.5345c3da.png";